<template>
  <div
    class="bg-background border-background-fg/8 flex flex-grow flex-col overflow-y-auto border-r pb-4 pt-5"
  >
    <div
      class="flex flex-shrink-0 flex-col items-center justify-center px-4"
    >
      <IconBrandLogo class="h-auto w-full" />
      <p
        class="text-primary w-full text-right text-xs font-bold"
        >Web Portal</p
      >
    </div>
    <div class="w-full flex-shrink-0 px-4">
      <p
        class="text-background-fg/70 line-clamp-2 w-full text-lg font-medium"
      >
        {{ tenantName }}
      </p>
    </div>
    <template
      v-if="
        youlendOffer &&
        organizationConfig?.businessFundingEnabled
      "
    >
      <div
        class="border-background-fg/20 border-t px-2 py-4"
      >
        <div class="pb-2">
          <IconAppAdvancePlusBig
            class="text-background-fg"
          />
          <p class="text-sm font-medium">
            You're prequalified for an advance of your
            payments.
          </p>
        </div>

        <RouterLink
          :class="[
            'h-15 bg-primary relative flex w-full cursor-pointer items-center justify-between rounded-lg p-3',
          ]"
          :to="{ name: 'advancePlus' }"
        >
          <div
            class="flex h-full items-center justify-center"
          >
            <BusinessFundingIcon
              class="animate-grow h-8 w-8"
            />
          </div>
          <div class="ml-3 flex-1">
            <p
              :class="[
                'text-primary-fg line-clamp-2 text-left text-xs font-semibold',
              ]"
            >
              Grow with <b>Advance+</b> now
            </p>
          </div>
          <div
            class="ml-3 flex h-full items-center justify-center"
          >
            <IconHeroiconsSolidChevronRight
              :class="['text-primary-fg/50 h-6 w-6']"
            />
          </div>
        </RouterLink>
      </div>
    </template>
    <div
      class="border-background-fg/20 mt-2 flex flex-grow flex-col border-t pt-4"
    >
      <nav
        class="bg-background flex flex-1 flex-col space-y-2 px-2"
        aria-label="Sidebar"
      >
        <template
          v-for="item in navigation"
          :key="item.name"
        >
          <template v-if="!item.children">
            <RouterLink
              #default="{
                href: childHref,
                navigate: childNavigate,
                route: { meta: childMeta },
                isExactActive: isChildActive,
              }"
              :to="{ name: item.name }"
              custom
            >
              <div
                :class="[
                  'space-y-1 border-l-2',
                  isChildActive
                    ? 'border-primary bg-background-fg/3 text-background-fg/87'
                    : 'text-background-fg/70 border-transparent bg-white',
                ]"
              >
                <a
                  :href="childHref"
                  :class="[
                    isChildActive
                      ? 'bg-primary/10'
                      : 'hover:bg-background-fg/3 hover:text-background-fg/87',
                    'text-background-fg/70 group flex w-full items-center rounded-md px-2 py-2 text-sm font-medium',
                  ]"
                  @click="childNavigate"
                >
                  <Component
                    :is="childMeta.icon"
                    :class="['mr-3 h-6 w-6 flex-shrink-0']"
                    aria-hidden="true"
                    @click="childNavigate"
                  />
                  {{ childMeta.pageTitle }}
                </a>
              </div>
            </RouterLink>
          </template>
          <template v-else>
            <RouterLink
              #default="{ isActive, route: { meta } }"
              custom
              :to="{ name: item.name }"
            >
              <div
                :class="[
                  'space-y-1 border-l-2',
                  isActive
                    ? 'border-primary bg-background-fg/3 text-background-fg/87'
                    : 'text-background-fg/70 border-transparent bg-white',
                ]"
              >
                <p
                  :class="[
                    'group flex w-full items-center rounded-md py-2 pl-2 pr-1 text-left text-xs font-medium',
                  ]"
                >
                  <span class="flex-1">{{
                    meta.pageTitle
                  }}</span>
                </p>
                <div class="space-y-1">
                  <template
                    v-for="subItem in item.children"
                    :key="subItem.name"
                  >
                    <RouterLink
                      #default="{
                        href: childHref,
                        navigate: childNavigate,
                        route: { meta: childMeta },
                        isExactActive: isChildActive,
                      }"
                      :to="{ name: subItem.name }"
                      custom
                    >
                      <a
                        :href="childHref"
                        :class="[
                          isChildActive
                            ? 'bg-primary/10'
                            : 'hover:bg-background-fg/3 hover:text-background-fg/87',
                          'text-background-fg/70 group flex w-full items-center rounded-md px-2 py-2 text-sm font-medium',
                        ]"
                        @click="childNavigate"
                      >
                        <Component
                          :is="childMeta.icon"
                          :class="[
                            'mr-3 h-6 w-6 flex-shrink-0',
                          ]"
                          aria-hidden="true"
                          @click="childNavigate"
                        />
                        {{ childMeta.pageTitle }}
                      </a>
                    </RouterLink>
                  </template>
                </div>
              </div>
            </RouterLink>
          </template>
        </template>
        <div class="flex-1"> </div>

        <template v-if="currentUser">
          <div class="bg-background-fg/20 h-px w-full" />
          <div class="space-y-1">
            <template v-if="!currentUser.isPublicAdmin">
              <div
                class="text-background-fg/80 flex items-center px-4 py-2 text-sm font-medium"
              >
                {{ currentUser.email }}
              </div>
              <RouterLink
                #default="{ navigate, href }"
                custom
                :to="{ name: 'changePassword' }"
              >
                <div class="relative">
                  <a
                    class="text-background-fg/50 hover:bg-background-fg/10 hover:text-background-fg/80 block w-full px-4 py-2 text-left text-base font-medium"
                    :href="href"
                    @click="navigate"
                  >
                    {{ changePasswordText }}
                  </a>
                  <template v-if="shouldAlertPassword">
                    <IconHeroiconsSolidExclamationCircle
                      class="text-error ah-4 absolute right-1 top-0 w-4"
                    />
                  </template>
                </div>
              </RouterLink>
            </template>
            <button
              class="text-background-fg/50 hover:bg-background-fg/10 hover:text-background-fg/80 block w-full px-4 py-2 text-left text-base font-medium"
              @click="onClickLogout"
            >
              Log Out
            </button>
          </div>
        </template>
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
import { queryClient } from "@/queryClient"
import BusinessFundingIcon from "~icons/app/advance-plus"
type Navigation = {
  name: string
  children?: {
    name: string
  }[]
}[]

const {
  name: tenantName,
  isProductsEnabled,
  isCashiersEnabled,
  hasSalesModule,
  resetTenant,
  youlendOffer,
} = useTenant()

const { organizationConfig } = useOrganizationConfig()

const navigation = computed(
  () =>
    [
      {
        name: "home",
      },
      {
        name: "reportsIndex",

        children: [
          {
            name: "reportsTransactions",
          },
          ...(hasSalesModule.value
            ? [{ name: "reportsSales" }]
            : []),

          ...(hasSalesModule.value &&
          isProductsEnabled.value
            ? [{ name: "reportsTopProducts" }]
            : []),
        ],
      },

      {
        name: "history",
        children: [
          ...(hasSalesModule.value
            ? [{ name: "historyOrders" }]
            : []),
          { name: "historyTransactions" },
        ],
      },

      {
        name: "manageMenu",

        children: [
          ...(hasSalesModule.value
            ? [
                ...(isProductsEnabled.value
                  ? [
                      { name: "manageProducts" },
                      { name: "manageCategories" },
                    ]
                  : []),
                ...(isCashiersEnabled.value
                  ? [{ name: "manageCashiers" }]
                  : []),
                ...(isProductsEnabled.value &&
                organizationConfig.value
                  ?.productImportsEnabled
                  ? [{ name: "importIndex" }]
                  : []),
              ]
            : []),

          {
            name: "usersIndex",
          },
          {
            name: "settings",
          },
        ],
      },
    ].filter(
      ({ children }) =>
        children === undefined || children.length > 0
    ) satisfies Navigation
)

const { currentUser } = useCurrentUser()
const { setToken } = useAuth()

const onClickLogout = () => {
  setToken(null)
  queryClient.invalidateQueries()
  resetTenant()
}

const shouldAlertPassword = computed(
  () => currentUser.value?.hasPassword === false
)
const changePasswordText = computed(() =>
  currentUser.value?.hasPassword
    ? "Change Password"
    : "Set Password"
)
</script>
